import { find, toLower, upperFirst } from 'lodash';
import { Weld, CrewMember, PersonaType } from '@bechtel/types';
import { t } from '@lingui/macro';
import { useConfig } from '@bechtel/client-common';

const getCrewMemberFullName = (crewMember?: CrewMember | null) => {
  return crewMember ? `${upperFirst(toLower(crewMember?.firstName))} ${upperFirst(toLower(crewMember.lastName))}` : '';
};
export const useWeldStatusText = (weld: Weld) => {
  const { features } = useConfig();
  const isFitupEnabled = features.canApproveFitupInspection ? features.canApproveFitupInspection : false;
  const commodityAssignee = weld.commodityAssignees?.length
    ? find(weld.commodityAssignees, (item) => {
        return item.personaType == PersonaType.FOREMAN;
      })
    : null;
  const assignedWeldForeman = commodityAssignee && commodityAssignee.assignee;
  if (!isFitupEnabled) {
    return t`Install: ${assignedWeldForeman?.id ? getCrewMemberFullName(assignedWeldForeman) : 'Unassigned'}`;
  } else if (weld?.fitupRequest?.isWeldingRequired && weld?.fitupRequest?.installationCrewMember) {
    return t`Fitup:  ${getCrewMemberFullName(
      weld?.fitupRequest?.installationCrewMember
    )}   | Install:  ${getCrewMemberFullName(weld?.fitupRequest?.installationCrewMember)}`;
  } else if (!weld?.fitupRequest?.isFitupRequired) {
    return t`Install:  ${
      weld?.fitupRequest?.installationCrewMember
        ? getCrewMemberFullName(weld?.fitupRequest?.installationCrewMember)
        : assignedWeldForeman
        ? getCrewMemberFullName(assignedWeldForeman)
        : 'Unassigned'
    }`;
  } else if (weld?.fitupRequest && !weld?.fitupRequest?.isWeldingRequired) {
    return t`Fitup:  Unassigned  | Install:  ${getCrewMemberFullName(weld?.fitupRequest?.installationCrewMember)}`;
  }
};
